/**
 * Bob Laadt Op — De kast in "Wat is een thuisbatterij?": vulling groeit één keer,
 * het cijfer telt mee (ontwerp: hoe-werkt-het.html, JS 2487–2508).
 *
 * Start zodra 40% van de kast in beeld is. Het doelpercentage komt uit
 * data-fill (sectie-instelling "Vulling"). Bij prefers-reduced-motion direct
 * de eindstand (de CSS zet dan ook de transitie van de vulling uit).
 * Custom element: na een re-render in de theme editor start hij opnieuw.
 */
class BobBattery extends HTMLElement {
  connectedCallback() {
    this.fill = this.querySelector('[data-batt-fill]');
    this.pct = this.querySelector('[data-batt-pct]');
    if (!this.fill || !this.pct) return;

    const doel = Math.max(0, Math.min(100, parseInt(this.dataset.fill, 10) || 0));
    const stilstaand = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const vulKast = () => {
      this.fill.style.height = doel + '%';
      if (stilstaand) {
        this.pct.textContent = String(doel);
        return;
      }
      const duur = 1600;
      const t0 = performance.now();
      const tel = (nu) => {
        const p = Math.min(1, Math.max(0, (nu - t0) / duur));
        /* zelfde uitdempende curve als de vulling, zodat cijfer en niveau
           gelijk oplopen */
        this.pct.textContent = String(Math.round(doel * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(tel);
      };
      requestAnimationFrame(tel);
    };

    if (stilstaand || !('IntersectionObserver' in window)) {
      vulKast();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            vulKast();
            obs.disconnect();
          }
        }
      },
      { threshold: 0.4 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('bob-battery')) customElements.define('bob-battery', BobBattery);
